import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { switchMap } from 'rxjs/operators';
import { UsersService } from 'src/app/_services/admin/users.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { PreventiveMaintenanceStandaloneService } from 'src/app/_services/preventive-maintenance-standalone.service';

@Component({
    selector: 'app-assign-to',
    templateUrl: './assign-to.component.html',
    styleUrls: ['./assign-to.component.scss'],
    standalone: false
})
export class AssignToComponent implements OnInit {
  data:any
  assignToOptions =[]
  addAssignToForm: UntypedFormGroup = new UntypedFormGroup({
    assignTo: new UntypedFormControl(null, [Validators.required]),
    assignType: new UntypedFormControl(null, [Validators.required]),
  });
  userList: any; // users list
  usersGroupList: any; // user groups list

  assignToData={assignmentType:null, assignedTo:null,index:null} // default value
  submitted:boolean=false;
  translate: any;
  constructor(
    public modalRef: BsModalRef,
    private userService: UsersService,
    private languageTranslateService: LanguageTranslateService,
    private preventiveMaintenanceStandaloneService: PreventiveMaintenanceStandaloneService
  ) { }

  ngOnInit(): void {
    console.log(this.data);

if(this.data.planType == 'ASSET'){
   this.assignToData.assignmentType=this.data.assignmentType == null ? 'CUSTODIAN' :this.data.assignmentType;
   this.assignToOptions = [
    {label: 'Asset Custodian', value: 'CUSTODIAN'},
    {label: 'Specific User', value: 'USER'},
    {label: 'User Group', value: 'GROUP'},
  ];
   
}else{
    this.assignToData.assignmentType=this.data.assignmentType == null ? null :this.data.assignmentType;
   this.assignToOptions = [
    {label: 'User', value: 'USER'},
    {label: 'Group', value: 'GROUP'},
  ];
}
  

  
   if(this.data.assignmentType == 'GROUP'){
    this.assignToData.assignedTo=this.data.userGroup;
   }else if(this.data.assignmentType == 'USER'){
    this.assignToData.assignedTo=this.data.user;
   }
    this.assignToData.index=this.data.index;
    this.getLanguageData()
   
  }
/******************************************** Get Language Data ******************************************/
  getLanguageData() {
   this.languageTranslateService.wordSrc$.subscribe((data) => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
         this.getOtherData();
      // Listen for changes to assignmentType and update assignTo validation
      this.addAssignToForm.get('assignType')?.valueChanges.subscribe((val) => {
        if (val === 'CUSTODIAN') {
          this.addAssignToForm.get('assignTo')?.clearValidators();
          this.addAssignToForm.get('assignTo')?.updateValueAndValidity();
        } else {
          this.addAssignToForm.get('assignTo')?.setValidators([Validators.required]);
          this.addAssignToForm.get('assignTo')?.updateValueAndValidity();
        }
      });
      }
    })
  
}
onAssignTypeChange(event: any) {
    this.addAssignToForm.patchValue({ assignedTo: null });
    this.assignToData.assignedTo = null;
  }
/******************************************** Return Label ******************************************/
  public returnLabel(what: string, value: string) {
    let label = "";

    if (what === "user") {
      const user = this.userList.find((user: any) => user.id === value);
      label = `${user.firstName} ${user.lastName}`;
    }

    return label;
  }
/******************************************** Get Other Data ******************************************/
  getOtherData() {
      this.userService.getAllDownlineUsersForBin().pipe(
        switchMap((categoryRes: any) => {
          this.userList = categoryRes;
          return this.userService.getAlluserGroup();
        })
      ).subscribe((userRes: any) => {
         this.usersGroupList = userRes;
      });
    }

/******************************************** On Back ******************************************/
  onBack() {
    // close and return to previous screen; or emit event
    this.modalRef.hide();
  }
  /******************************************** On Confirm ******************************************/
  onConfirm() {
     this.addAssignToForm.markAllAsTouched();
     this.addAssignToForm.updateValueAndValidity();
    if(this.addAssignToForm.invalid){
    
      return;
    }
       this.submitted=true;
    // this.assignToData.assignmentType=this.addAssignToForm.value.assignType;
    // this.assignToData.assignedTo=this.addAssignToForm.value.assignTo;
    console.log( this.assignToData);
    this.preventiveMaintenanceStandaloneService.setAssignedJobOrderTo(this.assignToData);
    this.modalRef.hide();
  } 

}
